import { useCallback, useEffect, useSyncExternalStore } from 'react';

/**
 * Two routes ("/" and "/t/:shareToken") do not justify a routing library, its
 * bundle, or its advisory surface. This is the whole router.
 */

const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn());

function subscribe(fn) {
  listeners.add(fn);
  window.addEventListener('popstate', notify);
  return () => {
    listeners.delete(fn);
    if (listeners.size === 0) window.removeEventListener('popstate', notify);
  };
}

const snapshot = () => window.location.pathname + window.location.search;

export function navigate(to, { replace = false } = {}) {
  if (snapshot() === to) return;
  window.history[replace ? 'replaceState' : 'pushState']({}, '', to);
  notify();
}

export function useRoute() {
  const href = useSyncExternalStore(subscribe, snapshot, () => '/');
  const path = href.split('?')[0];
  const match = path.match(/^\/t\/([A-Za-z0-9_-]{16,64})\/?$/);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [path]);

  return {
    href,
    path,
    name: match ? 'trip' : 'home',
    shareToken: match?.[1] ?? null,
    navigate: useCallback(navigate, []),
  };
}
